module.exports = __webpack_public_path__ + "static/img/item-6-2-big.034e43d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-6-2-big.png
// module id = NEFf
// module chunks = 2